import { render, staticRenderFns } from "./DonoMedia.vue?vue&type=template&id=1ab8ef36"
import script from "./DonoMedia.vue?vue&type=script&lang=js"
export * from "./DonoMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports